'use client'

import { GalleryBlock as GalleryBlockProps } from '@onclicks/payload-types'
import React, { useState } from 'react'
import { courierPrime } from '@onclicks/utilities/fontImport'
import { cn } from '@onclicks/utilities/ui'
import { Media } from '../Media/Media'
import { CMSLink } from '../CMSLink'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Button } from '../ui/Button'

const ACTIVE_GROW = 6
const INACTIVE_GROW = 1

export const FocusDisplay: React.FC<GalleryBlockProps> = ({
  anchor,
  title,
  images,
  enableLink,
  link,
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const count = images?.length ?? 0

  const goPrev = () => setActiveIndex((i) => (i - 1 + count) % count)
  const goNext = () => setActiveIndex((i) => (i + 1) % count)

  return (
    <section
      id={(anchor?.value && typeof anchor.value === 'object' && anchor?.value.anchor) || ''}
      className="flex w-full flex-col items-center gap-10 py-16"
    >
      {title && (
        <h2
          className={cn(
            courierPrime.className,
            'text-center text-3xl font-bold uppercase md:text-4xl',
          )}
        >
          {title}
        </h2>
      )}

      {images && images.length > 0 && (
        <>
          {/* Rangée de photos */}
          <div className="flex h-80 w-full max-w-5xl items-stretch justify-center gap-6 md:h-105 md:gap-6">
            {images.map((item, index) => {
              const isActive = index === activeIndex

              return (
                <button
                  key={item.id ?? index}
                  type="button"
                  onClick={() => setActiveIndex(index)}
                  className="relative h-full min-w-0 transition-[flex-grow] duration-700 ease-in-out"
                  style={{
                    flexGrow: isActive ? ACTIVE_GROW : INACTIVE_GROW,
                    flexShrink: 0,
                    flexBasis: 0,
                  }}
                >
                  {/* Conteneur qui rogne l'image */}
                  <div className="relative h-full w-full overflow-hidden rounded-3xl">
                    {item.image && (
                      <Media resource={item.image} fill imgClassName="h-full w-full object-cover" />
                    )}
                  </div>

                  {/* Bordure décalée, hors du conteneur rogné */}
                  <div className="pointer-events-none absolute -inset-2 z-10 rounded-3xl border border-black" />
                </button>
              )
            })}
          </div>

          {/* Flèches de navigation */}
          <div className="flex items-center gap-8">
            <Button type="button" variant="default" onClick={goPrev} className="flex h-10 w-10">
              <FontAwesomeIcon icon={faChevronLeft} className="text-lg" />
            </Button>
            <Button
              type="button"
              variant="defaultReversed"
              onClick={goNext}
              className="flex h-10 w-10"
            >
              <FontAwesomeIcon icon={faChevronRight} className="text-lg" />
            </Button>
          </div>
        </>
      )}

      {enableLink && link && <CMSLink {...link} />}
    </section>
  )
}
